import type { MaterialResource } from '@/material/web/api'
import type DataFileMap from '@/model/Resource/DataFileMap'
import { buildDollCompositeSignature, getMaterialSourceDownloadUrl } from '@/features/material-library/apply'
import {
  hasMaterialResourceMappingByCompositeSignature,
  hasMaterialResourceMappingBySourceUrl,
} from '@/features/material-library/resourceMapping'
import { getMaterialApplyTarget, isUiMaterialCategory } from '@/features/material-library/targets'

/** 获取当前素材选择对应的虚拟资源分类根。 */
export function resolveMaterialUsageRoot(
  topCategoryId: string,
  roots: Record<string, DataFileMap | null | undefined>,
): DataFileMap | null {
  if (isUiMaterialCategory(topCategoryId)) {
    return roots.graphic ?? null
  }
  const target = getMaterialApplyTarget(topCategoryId)
  return target ? roots[target.category] ?? null : null
}

/** 判断当前一组选中的素材资源是否已经全部导入过。 */
export function areMaterialResourcesAlreadyApplied(
  root: DataFileMap | null,
  resources: MaterialResource[],
): boolean {
  const sourceUrls = Array.from(
    new Set(resources.map((item) => getMaterialSourceDownloadUrl(item)).filter(Boolean)),
  )
  if (!sourceUrls.length) return false
  return sourceUrls.every((sourceUrl) => hasMaterialResourceMappingBySourceUrl(root, sourceUrl))
}

/** 判断当前立绘组合是否已经以“合成图”形式导入过。 */
export function isDollCompositeAlreadyApplied(
  root: DataFileMap | null,
  params: {
    goodsId: string
    size: string
    resources: MaterialResource[]
  },
): boolean {
  const signature = buildDollCompositeSignature(params)
  if (!signature) return false
  return hasMaterialResourceMappingByCompositeSignature(root, signature)
}
